const extraServices = {
  header: {
    btnCreate: 'Erstellen',
  },

  toast: {
    error: {
      badResponse: '[Extra Service] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Extra Service] erfolgreich erstellt',
      },
      edit: {},
      delete: {
        default: '[Extra Service] erfolgreich gelöscht',
      },
    },
  },

  deleteModal: {
    header: 'Zusatzleistungen löschen',
    body: 'Sie sind dabei, {{num}} Zusatzdienste zu löschen.',
  },

  table: {
    filters: {
      profileType: 'Profiltyp'
    },
    headers: {
      name: 'Zusatzdienste',
      profileType: 'Profiltyp',
      basePrice: 'Basis',
      extraPrice: 'Jeder Zusatz',
      baseUpTo: 'Basis bis zu',
      surcharge: 'Zuschlag',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
  },

  create: {
    successToast: {
      message: 'Erfolg! Zusatzdienst erstellt',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Der Zusatzdienst konnte nicht erstellt werden.',
    },
  },

  edit: {
    successToast: {
      message: 'Erfolg! Zusatzdienst aktualisiert',
    },
    errorToast: {
      message: 'Ein Fehler ist aufgetreten. Der Zusatzdienst konnte nicht aktualisiert werden.',
    },
  },

  forms: {
    header: {
      createExtraService: {
        title: 'Erstellen',
      },

      updateExtraService: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Zusatzdienste',
          profileType: 'Profiltyp',
          description: 'Beschreibung',
          profileTypeOptions: {
            retail: 'Einzelhandel',
            individual: 'Individuell',
            wholesale: 'Großhandel',
            corporate: 'Unternehmen',
            website: 'Webseite',
            hotel: 'Hotel',
            thirdParty: 'Drittanbieter',
            tourOperator: 'Fahrtbetreiber',
            receiptiveOperator: 'Empfangsoperator',
          },
        },
      },
      settings: {
        header: 'Einstellungen',
        fields: {
          basePrice: 'Basis',
          extraPrice: 'Jeder Zusatz',
          baseUpTo: 'Basis bis zu',
          surcharge: 'Zuschlag',
        },
      },
    },
  },
};

export default extraServices;
